import styled from "styled-components";

export const Hover = styled.span`
  color: #333;
  :hover {
    text-decoration: underline;
    transition: all ease 500ms;
    color: var(--lightBlue);
  }
`;
